<div class="en banner center" style="max-width:800px;margin-top:10px;margin-bottom: 10px;">
  <div class="row styled_row">
    <div class="col-sm-3">
      <label>Device Time</label>
    </div>
    <div class="col-sm-9">
      {{dateTime}}
    </div>
  </div>
  <div class="row styled_row">
    <div class="col-sm-3">
      <label>UTC Offset in Minutes</label>
    </div>
    <div class="col-sm-9">
      {{offset}}
    </div>
  </div>
  <div class="row styled_row">
    <div class="col-3">
      <label>Size</label>
    </div>
    <div class="col-9">
      {{size}}
    </div>
  </div>
  <div class="row styled_row">
    <div class="col-sm-3">
      <label>Agent</label>
    </div>
    <div class="col-sm-9">
      {{agent}}
    </div>
  </div>
  <div class="row styled_row">
    <div class="col-sm-3">
      <label>Number Keys</label>
      <span *ngIf="pressedNumKeyChar">&nbsp;({{pressedNumKeyChar}})&nbsp;</span>
    </div>
    <div class="col-sm-9">
      <input type="number" (keypress)="onKeyPress($event,1)" placeholder="Type here.." />
    </div>
  </div>
  <div class="row styled_row">
    <div class="col-sm-3">
      <label>Text Keys</label>
      <span *ngIf="pressedTextKeyChar">&nbsp;({{pressedTextKeyChar}})&nbsp;</span>
    </div>
    <div class="col-sm-9">
      <input type="text" (keypress)="onKeyPress($event,2)" placeholder="Type here.." />
    </div>
  </div>
  <div class="row styled_row">
    <div class="col-sm-3">
      <label>Media Details</label>
    </div>
    <div class="col-sm-9" style="overflow-wrap: break-word;">
      {{mediaDeviceInfo}}
    </div>
  </div>
  <div class="row styled_row">
    <div class="col-sm-3">
      <label>Camera Details</label>
    </div>
    <div class="col-sm-9" style="overflow-wrap: break-word;">
      {{mediaDeviceInfoVideo}}
    </div>
  </div>
  <div class="row styled_row">
    <div class="col-sm-3">
      <label>Bluetooth Devices</label>
    </div>
    <div class="col-sm-9" style="overflow-wrap: break-word;">
      {{blutoothDevices}}
    </div>
  </div>
  <div class="row styled_row">
    <div class="col-sm-3">
      <label>Bluetooth Connect</label>
      <small *ngIf="isBluetoothConnected == true" style="color:green;">(Connected)</small>
      <small *ngIf="isBluetoothConnected == false" style="color:red;">(Not Connected)</small>
      <div style="margin-top: 10px;text-align: center;">
        <button class="btn btn-primary" (click)="onConnectBluetooth()">Connect</button>
      </div>
      <div style="margin-top: 10px;text-align: center;">
        <button class="btn btn-primary" [disabled]="!(isBluetoothConnected == true)"
          (click)="onTestPrintBluetooth()">Test Print</button>
      </div>
    </div>
    <div class="col-sm-9" style="overflow-wrap: break-word;">
      <input type="text" [(ngModel)]="optionalServicesUuid" placeholder="Type Service UUID.." />
      <br />
      <input type="text" [(ngModel)]="gattServiceUUID" placeholder="Type GATT UUID.." />
      <br />
      <input type="text" [(ngModel)]="characteristicUUID" placeholder="Type Characteristic UUID.." />
    </div>
  </div>
</div>